import { Component, OnInit, signal } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { Header } from "./shared/components/header/header";
import { Footer } from "./shared/components/footer/footer";
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, RouterModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {

  cookieContainer = signal<boolean>(false);

  ngOnInit(): void {
    this.checkCookies();
  }
  checkCookies(): void {
    const cookies = document.cookie.split(';');
    const accepted = cookies.find(cookie => cookie.trim().startsWith('snf_cookie=accept'));
    if (!accepted) {
      this.cookieContainer.set(true);
    }
  }

  acceptCookies(): void {
    // 30 days
    const today = new Date();
    const expiresDate = new Date(today);
    expiresDate.setDate(today.getDate() + 30);
    document.cookie = `snf_cookie=accept;expires=${expiresDate.toUTCString()};path=/`;
    this.cookieContainer.set(false);
  }
}

